(() => {
  const initProduct = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const gallery = root.querySelector('.product-gallery');
    const purchase = root.querySelector('.product-info');
    const shortcut = root.querySelector('[data-purchase-shortcut]');
    if (purchase && shortcut && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => { shortcut.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; }, {threshold: 0});
      observer.observe(purchase);
    }
    const move = (direction) => {
      const media = gallery?.querySelector('.product-media');
      if (media) gallery.scrollBy({left: direction * (media.getBoundingClientRect().width + parseFloat(getComputedStyle(gallery).columnGap || 0)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => move(-1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => move(1));
    const select = root.querySelector('[data-variant-select]');
    root.querySelectorAll('[data-gallery-target]').forEach(button => button.addEventListener('click', () => {
      const target = document.getElementById(button.dataset.galleryTarget);
      if (target && gallery) gallery.scrollTo({left: target.offsetLeft - gallery.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }));
    const choices = root.querySelectorAll('[data-variant-choice]');
    if (choices.length) root.classList.add('has-variant-choices');
    choices.forEach(choice => choice.addEventListener('change', () => {
      if (choice.checked && select) { select.value = choice.value; select.dispatchEvent(new Event('change')); }
    }));
    select?.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      choices.forEach(choice => { choice.checked = choice.value === select.value; });
      const button = root.querySelector('[data-add-button]');
      const price = root.querySelector('[data-price]');
      const quantity = root.querySelector('[name="quantity"]');
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
      price.replaceChildren(document.createTextNode(option.dataset.price));
      if (option.dataset.compare) {
        const compare = document.createElement('s');
        compare.textContent = option.dataset.compare;
        price.append(document.createTextNode(' '), compare);
      }
      quantity.min = option.dataset.min || '1';
      quantity.step = option.dataset.step || '1';
      if (option.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
      quantity.value = quantity.min;
      const target = [...root.querySelectorAll('[data-media-id]')].find(el => el.classList.contains('product-media') && el.dataset.mediaId === option.dataset.mediaId);
      if (target && gallery) gallery.scrollTo({left: target.offsetLeft - gallery.offsetLeft, behavior: 'instant'});
      const url = new URL(location.href);
      url.searchParams.set('variant', select.value);
      history.replaceState({}, '', url);
    });
  };
  const init = () => document.querySelectorAll('[data-product-root]').forEach(initProduct);
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('[data-disclosure][open]').forEach(details => {
      details.removeAttribute('open');
      details.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-disclosure][open]').forEach(details => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });
})();
